import React, { useState, useEffect } from "react";
import Modal from "./../../shared/Modal/";
import { useForm, Controller } from "react-hook-form";
import { Spinner } from "react-bootstrap";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useHistory } from "react-router-dom";
import moment from "moment";
import store from "../../../redux/store";

// Constants
import ARTISTS from "../../../public/locals/artists.json";
import usertTypes from "./../hv-form/userTypes.json";
import states from "../../../public/locals/states.json";

import { ReactComponent as Visible } from "./../../../public/visible.svg";
import { ReactComponent as Invisible } from "./../../../public/invisible.svg";

import { signup } from "../../../api/guests";
import { listCountries } from "../../../api/location";
import ContactInfo from "../../Onboarding/routes/ContactInfo";
import "./styles.scss";
import { isValidPhoneNumber } from "libphonenumber-js";

export default function App(props) {
  const [showPassword, setShowPassword] = useState(false);
  const [zipCode, setZipCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [countries, setCountries] = useState("");
  const [errors, setErrors] = useState([]);
  const { register, handleSubmit, watch, setValue, control } = useForm({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
  });
  const history = useHistory();

  const [countryCode, setCountryCode] = useState("1");

  const [isCityRequired, setIsCityRequired] = useState(false);

  useEffect(() => {
    const rootElement = document.getElementById("root");
    rootElement?.classList.add("overflow-hidden");
    listCountries(["name", "alpha2Code"]).then(({ data }) => {
      let countries = data.data.sort((a, b) => (a.name === "United States of America" ? -1 : 0));
      countries = countries.map((c) => ({
        ...c,
        name: c.alpha2Code === "GB" ? "United Kingdom" : c.name,
      }));
      setCountries(countries);
    });
    return () => rootElement?.classList.remove("overflow-hidden");
  }, []);

  useEffect(() => {
    if (["United States of America", "USA"].includes(watch("address_attributes[country]"))) {
      setIsCityRequired(true);
      setZipCode((zip) => zip.slice(0, 5));
    } else {
      setIsCityRequired(false);
    }
  }, [watch("address_attributes[country]")]);
  const countryNumber = watch("phone_number_attributes[number]");
  const fillForm = () => {
    let rand = Math.floor(Math.random() * 12345);
    setValue("email", `hazemturki+${rand}@gmail.com`);
    setValue("username", `hazemturki${rand}`);
    setValue("password", "Killme1996");
    setValue("password_confirmation", "Killme1996");
    setValue("first_name", "Hazem");
    setValue("last_name", "Turki");
    setValue("date_of_birth", new Date("08/10/1996"));
    setValue("address_attributes[country]", "United States of America");
    setValue("address_attributes[city]", "California");
    setValue("address_attributes[state]", "LA");
    setValue("address_attributes[address1]", "Addess");
    setValue("address_attributes[address2]", "Apartment #, Unit, Suite, etc");
    setValue("phone_number_attributes[code]", "1");
    setValue("phone_number_attributes[number]", "+13216549870");
    setValue("address_attributes[zip]", "12345");
  };

  const getArtistTypesOptions = () => {
    let artistsInfo = ARTISTS["types"];
    let options = Object.keys(artistsInfo).map((k) => {
      return <option key={k}>{k}</option>;
    });
    return options;
  };

  const onSubmit = async (params) => {
    // console.log(params);
    setLoading(true);
    params.date_of_birth = moment(params.date_of_birth).format("DD/MM/YYYY");
    params.referrer = localStorage.getItem("utms");
    params.phone_number_attributes.code = countryCode;

    var errors = [];
    var isError = false;

    if (params.address_attributes.country.length == 0) {
      isError = true;
      errors.push("country");
    }

    if (!params.address_attributes.state || params.address_attributes.state.length == 0) {
      isError = true;
      errors.push("state");
    }

    if (params.address_attributes.address1.length == 0) {
      isError = true;
      errors.push("address1");
    }

    if (params.address_attributes.city.length == 0) {
      isError = true;
      errors.push("city");
    }

    if (params.address_attributes.zip.length == 0) {
      isError = true;
      errors.push("zip");
    }

    if (params.artist_profile_attributes && params.artist_profile_attributes.artist_type == "") {
      isError = true;
      errors.push("artist_profile");
    }

    console.log("phone number valid status:", params.phone_number_attributes.number, isValidPhoneNumber(params.phone_number_attributes.number || ""));
    if (isValidPhoneNumber(params.phone_number_attributes.number || "")) {
      isError = true;
      errors.push("phone_number");
    }
    const boxes = document.querySelectorAll(".hv-error");

    boxes.forEach((box) => {
      box.remove();
    });

    errors.forEach((key) => {
      var element = document.getElementById(key);
      var error_tag = document.createElement("div");
      error_tag.textContent = "This field is required";

      if (key == "phone_number") {
        return;
        error_tag.setAttribute("style", "margin-bottom: -24px");
      }

      error_tag.setAttribute("class", "hv-error");
      if (element) {
        element.parentElement?.appendChild(error_tag);
      } else {
        console.log("can't find element", key);
      }
    });
    if (isError) {
      setLoading(false);
    } else {
      try {
        await signup({ guest: params });
        history.replace("/interest");
      } catch (form_errors) {
        console.log(form_errors);
        form_errors.forEach(({ code, message }) => {
          if (code == 1018) {
            console.log("sumit" + params.email);
            history.replace("/resend-confirmation?" + encodeURI(params.email));
          } else {
            setErrors(form_errors);
            setLoading(false);
          }
        });
      } finally {
        setLoading(false);
      }
    }
  };

  // Object.keys(errors).forEach((key) => {
  //   let hook_errors = errors[key].ref ? [errors[key]] : Object.keys(errors[key]).map((sub_key) => errors[key][sub_key]);
  //   hook_errors.forEach((hook_error) => {
  //     var error_tag = document.createElement("div");
  //     error_tag.textContent = hook_error.message;
  //     error_tag.setAttribute("class", "hv-error");
  //     if (hook_error.ref instanceof HTMLElement) {
  //       hook_error.ref.parentElement?.appendChild(error_tag);
  //     } else {
  //       document.getElementById(hook_error.ref.name) && document.getElementById(hook_error.ref.name).parentElement?.appendChild(error_tag);
  //     }
  //   });
  // });

  const validateBirthday = (birthday) => {
    const yearDiff = moment().diff(moment(new Date(birthday), "DD/MM/YYYY"), "years");
    if (yearDiff < 13) {
      props.setShowBanKids(true);
      return "SORRY, YOU NEED TO BE AT LEAST 13 YEARS OLD TO JOIN UNIFI MUSIC, BUT THANKS FOR CHECKING US OUT.";
    }
    return true;
  };

  const nameRegex = /^[A-Za-z0-9À-ÖØ-öø-ÿ \-']+$/;
  const usernameValidation = {
    required: {
      message: "This field is required",
    },
    pattern: {
      value: /^[A-Za-z0-9À-ÖØ-öø-ÿ \-/']+$/,
      message: "Oops! Your Display Name should use only letters, numbers, spaces, slashes, dashes or apostrophes.",
    },
  };

  const handleChangeRow = (e) => {
    const regex = /^[0-9\/]*$/;
    const value = e.target.value;
    const length = value.length;
    if (length >= 11 || !regex.test(value)) {
      e.preventDefault();
    }
    if (value.includes("/")) {
      const splittedDate = value.split("/");
      const dayMonth = splittedDate[0] + "/" + splittedDate[1];
      const year = splittedDate[2];
      const currentYear = new Date().getFullYear();
      if (year > currentYear) {
        e.target.value = dayMonth + "/" + currentYear;
      }
    }
  };

  return (
    <Modal id="signup" modaltitle="Sign Up">
      {!process.env.NODE_ENV ||
        (process.env.NODE_ENV === "development" && (
          <span className="btn bg-black text-white" onClick={fillForm}>
            Fill Form
          </span>
        ))}
      <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
        <div className="form-group">
          <input
            className="form-control hv-input"
            name="email"
            placeholder="Email"
            type="email"
            ref={register({
              required: { message: "This field is required" },
            })}
          />
        </div>
        <div className="form-group position-relative">
          {showPassword ? (
            <Visible className="passwordVisibility" onClick={() => setShowPassword(false)} />
          ) : (
            <Invisible className="passwordVisibility" onClick={() => setShowPassword(true)} />
          )}
          <input
            className="form-control hv-input"
            name="password"
            placeholder="Password"
            type={showPassword ? "text" : "password"}
            ref={register({
              required: { message: "This field is required" },
              pattern: {
                value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*?[0-9]).{6,}$/,
                message: "Password needs at least 6 characters with uppercase, lowercase and number.",
              },
            })}
          />
        </div>
        <div className="form-group">
          <input
            className="form-control hv-input"
            name="password_confirmation"
            placeholder="Confirm Password"
            type={showPassword ? "text" : "password"}
            ref={register({
              required: { message: "This field is required" },
            })}
          />
        </div>
        <div className="form-group form-row">
          <div className="col">
            <input
              type="text"
              className="form-control hv-input text-capitalize"
              name="first_name"
              placeholder="First name"
              maxLength={26}
              ref={register({
                required: { message: "This field is required" },
                pattern: {
                  value: nameRegex,
                  message: "Incorrect format",
                },
              })}
            />
          </div>
          <div className="col">
            <input
              type="text"
              className="form-control hv-input text-capitalize"
              name="last_name"
              placeholder="Last name"
              maxLength={26}
              ref={register({
                required: { message: "This field is required" },
                pattern: {
                  value: nameRegex,
                  message: "Incorrect format",
                },
              })}
            />
          </div>
        </div>
        <div className="form-group">
          <Controller
            as={ReactDatePicker}
            control={control}
            valueName="selected"
            onChange={([selected]) => selected}
            id="date_of_birth"
            name="date_of_birth"
            rules={{
              required: { message: "This field is required" },
              validate: (date) => validateBirthday(date),
            }}
            className="hv-input form-control"
            placeholderText="Date of birth MM/DD/YYYY"
            maxDate={new Date()}
            onChangeRaw={handleChangeRow}
          />
        </div>
        <div className="form-group form-row justify-content-between py-4">
          <h5 className="text-dark title-radio font-weight-bold col-100">User type</h5>
          <div id="userTypes-section" className="user-type-wrapper d-flex justify-content-between w-100 signup-radio">
            {usertTypes.map(({ name, title }, i) => (
              <div key={i} className="radio-wrapper">
                <div className="custom-control custom-radio custom-control-inline">
                  <input
                    className="custom-control-input"
                    type="radio"
                    name="guest_type"
                    defaultChecked={i === 0}
                    id={`${name}-radio`}
                    value={name}
                    ref={register({ required: true })}
                  />
                  <label className="custom-control-label text-primary font-weight-light" htmlFor={`${name}-radio`}>
                    {title}
                  </label>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="form-group form-row">
          {watch("guest_type") === "artist" ? (
            <>
              <div className="col">
                <input
                  className="hv-input form-control"
                  name="username"
                  maxLength={26}
                  placeholder="Display Name"
                  ref={register(usernameValidation)}
                />
              </div>
              <div className="col">
                <select
                  className="custom-select hv-select"
                  id="artist_profile"
                  name="artist_profile_attributes[artist_type]"
                  ref={register({
                    required: {
                      message: "This field is required",
                    },
                  })}
                >
                  <option value="" disabled>
                    Artist type
                  </option>
                  {getArtistTypesOptions()}
                </select>
              </div>
            </>
          ) : watch("guest_type") === "label" ? (
            <div className="col">
              <input
                className="hv-input form-control"
                name="username"
                maxLength={26}
                placeholder="Entertainment Label / Company name"
                ref={register(usernameValidation)}
              />
            </div>
          ) : (
            <div className="col">
              <input className="hv-input form-control" name="username" maxLength={26} placeholder="Display Name" ref={register(usernameValidation)} />
            </div>
          )}
        </div>
        <div className="form-row">
          <div className="form-group col-100">
            <select
              className="custom-select hv-select"
              name="address_attributes[country]"
              id="country"
              ref={register({
                required: { message: "This field is required" },
              })}
            >
              <option value="" disabled>
                Country
              </option>
              {countries.length &&
                countries.map((country, i) => (
                  <option key={i} value={country.name}>
                    {country.name}
                  </option>
                ))}
            </select>
          </div>
          <div className="form-group col-100">
            {["United States of America", "USA"].includes(watch("address_attributes[country]")) ? (
              <select
                id="state"
                className="custom-select hv-select"
                name="address_attributes[state]"
                ref={register({
                  required: { message: "This field is required" },
                })}
              >
                <option value="">State/Province</option>
                {states.map((state) => (
                  <option key={state.abbreviation} value={state.abbreviation}>
                    {state.name}
                  </option>
                ))}
              </select>
            ) : (
              <input
                type="text"
                className="hv-input form-control"
                placeholder="State/Province"
                name="address_attributes[state]"
                id="state"
                ref={register({
                  required: { message: "This field is required" },
                })}
              />
            )}
          </div>
          <div className="form-group col-50">
            <input
              type="text"
              className="hv-input form-control"
              placeholder="City"
              name="address_attributes[city]"
              id="city"
              ref={register({
                required: isCityRequired ? { message: "This field is required" } : false,
              })}
            />
          </div>
          <div className="form-group col-50">
            <input
              type="text"
              className="hv-input form-control"
              placeholder="Zip"
              name="address_attributes[zip]"
              id="zip"
              value={zipCode}
              onChange={(e) => {
                let val = e.target.value.replace(/\D/g, "");
                if (isCityRequired) {
                  val = val.slice(0, 5);
                }
                setZipCode(val);
              }}
              ref={register({
                required: { message: "This field is required" },
              })}
            />
          </div>
          <div className="form-group col-50">
            <input
              type="text"
              className="hv-input form-control"
              placeholder="Address"
              name="address_attributes[address1]"
              id="address1"
              ref={register({
                required: { message: "This field is required" },
              })}
            />
          </div>
          <div className="form-group col-50">
            <input
              type="text"
              className="hv-input form-control"
              placeholder="Apartment, Unit, Suite, etc"
              name="address_attributes[address2]"
              id="address2"
              ref={register}
            />
          </div>
          <ContactInfo disabled={loading} countries={countries} code={countryCode} setCode={setCountryCode} register={register} />
        </div>
        <div>
          {errors.map((a) => (
            <div className="alert alert-danger" role="alert">
              {a.message}
            </div>
          ))}
        </div>
        <div id="signup_actions" className="text-center">
          <p>
            By entering your phone number, you consent to receive welcome and marketing messages from UNIFI Music via SMS (no more than 3 per month).
            Message and data rates may apply. You can reply STOP to opt out at any time.
          </p>
          <p>
            By clicking below, you agree to UNIFI's MUSIC{" "}
            <a href="/terms-of-use" target="_blank">
              Terms of Use
            </a>
            , and have read & understand our{" "}
            <a href="/privacy-policy" target="_blank">
              Privacy Policy
            </a>{" "}
            and{" "}
            <a href="/eula" target="_blank">
              End User License Agreement
            </a>
            .
          </p>
          <button disabled={loading} className="btn btn-md btn-primary">
            {loading && <Spinner as="span" size="sm" animation="border" variant="light" style={{ marginRight: 20 }} />}
            <span className="position-relative" style={{ top: "1px", left: "1px" }}>
              Sign up
            </span>
          </button>
        </div>
      </form>
    </Modal>
  );
}
